import { GA_MEASUREMENT_ID } from '../config/api';

/** GA se učitava iz public/index.html; ovo je rezerva ako gtag još nije spreman. */
export const ensureGoogleAnalytics = () => {
  if (!GA_MEASUREMENT_ID || typeof window === 'undefined') return false;
  if (typeof window.gtag === 'function') return true;

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    window.dataLayer.push(arguments);
  };
  window.gtag('js', new Date());
  window.gtag('config', GA_MEASUREMENT_ID);
  return true;
};

export const trackGoogleAnalyticsPageView = (pagePath, pageTitle) => {
  if (!GA_MEASUREMENT_ID) return;
  if (!ensureGoogleAnalytics()) return;

  window.gtag('config', GA_MEASUREMENT_ID, {
    page_path: pagePath,
    page_title: pageTitle || document.title
  });
};

export const trackGoogleAnalyticsEvent = (eventName, params = {}) => {
  if (!GA_MEASUREMENT_ID) return;
  if (!ensureGoogleAnalytics()) return;
  window.gtag('event', eventName, params);
};

/** Klik na CTA (Registracija, Prijava, Demo, …) */
export const trackCtaClick = (ctaName, params = {}) => {
  trackGoogleAnalyticsEvent('cta_click', {
    cta_name: ctaName,
    page_path:
      typeof window !== 'undefined'
        ? window.location.pathname + window.location.search
        : '',
    ...params
  });
};

/** Slanje forme */
export const trackFormSubmit = (formName, params = {}) => {
  trackGoogleAnalyticsEvent('form_submit', { form_name: formName, ...params });
};

export const trackFormSuccess = (formName, params = {}) => {
  trackGoogleAnalyticsEvent('form_success', { form_name: formName, ...params });
};

export const trackFormError = (formName, params = {}) => {
  trackGoogleAnalyticsEvent('form_error', { form_name: formName, ...params });
};

/** Telefon / email u footeru */
export const trackContactClick = (contactType, params = {}) => {
  trackGoogleAnalyticsEvent('contact_click', {
    contact_type: contactType,
    ...params
  });
};
